import classNames from "classnames";
import { Flex, Text } from "@simplybusiness/mobius";

export type PriceBlockProps = {
  className?: string;
  pricePrefix?: string;
  priceValue: number | string;
  currencySymbol?: string;
  frequency?: string;
  referenceMark?: string;
  children?: React.ReactNode;
};

const DEFAULT_FREQUENCY = "month";
const DEFAULT_PREFIX = "From";
const DEFAULT_CURRENCY_SYMBOL = "$";

export const PriceBlock = ({
  className,
  pricePrefix = DEFAULT_PREFIX,
  priceValue,
  currencySymbol = DEFAULT_CURRENCY_SYMBOL,
  frequency = DEFAULT_FREQUENCY,
  referenceMark,
  children,
}: PriceBlockProps) => {
  const wrapperClass = classNames("mobius-price-block", className);
  const formattedValue = String(priceValue);

  return (
    <Flex className={wrapperClass}>
      <div className="mobius-price-block__price">
        <Text className="mobius-price-block__prefix">{pricePrefix}</Text>
        <Text elementType="p" className="mobius-price-block__value">
          {`${currencySymbol}${formattedValue} `}
          <Text elementType="span" className="mobius-price-block__suffix">
            /{` ${frequency}`}
            {referenceMark && (
              <sup data-testid="total-price-reference-mark">
                {referenceMark}
              </sup>
            )}
          </Text>
        </Text>
      </div>
      {children}
    </Flex>
  );
};

PriceBlock.displayName = "PriceBlock";
